import "./about.css";
import { AiOutlineHtml5 } from "react-icons/ai";
import { BsWordpress } from "react-icons/bs";
import { FaNode } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { FaLaravel } from "react-icons/fa";

export default function About() {
  return (
    <>
      <h1 className="title_skills heading-primary-main">MY SKILLS</h1>
      <div className="flexs">
        <figure class="skills">
          <figcaption>
            <h1>
              <AiOutlineHtml5 />
            </h1>
            <h2>HTML</h2>
            <h5>FrontEnd</h5>
          </figcaption>
        </figure>

        <figure class="skills">
          <figcaption>
            <h1>
              <BsWordpress />
            </h1>
            <h2>WORDPRESS</h2>
            <h5>FrontEnd</h5>
          </figcaption>
        </figure>
        <figure class="skills">
          <figcaption>
            <h1>
              <FaNode />
            </h1>
            <h2>Node Js</h2>
            <h5>BackEnd</h5>
          </figcaption>
        </figure>
        <figure class="skills">
          <figcaption>
            <h1>
              <FaReact />
            </h1>
            <h2>React</h2>
            <h5>FrontEnd</h5>
          </figcaption>
        </figure>
        <figure class="skills">
          <figcaption>
            <h1>
              <FaPython />
            </h1>
            <h2>Python</h2>
            <h5>BackEnd</h5>
          </figcaption>
        </figure>
        <figure class="skills">
          <figcaption>
            <h1>
              <FaLaravel />
            </h1>
            <h2>Laravel</h2>
            <h5>BackEnd</h5>
          </figcaption>
        </figure>
      </div>
    </>
  );
}
